export const safePercentage = (value: number, total: number): number => {
	if (!total || total === 0 || !isFinite(value) || !isFinite(total)) return 0;
	const percentage = Math.floor((value / total) * 100);
	// Retornar 0 se a porcentagem não estiver entre 0 e 100
	if (percentage < 0 || percentage > 100) return 0;
	return percentage;
};

export const formatMonthLabel = (monthString: string): string => {
	const months = [
		"JAN",
		"FEV",
		"MAR",
		"ABR",
		"MAI",
		"JUN",
		"JUL",
		"AGO",
		"SET",
		"OUT",
		"NOV",
		"DEZ",
	];
	const [, month] = monthString.split("-");
	const monthIndex = parseInt(month, 10) - 1;
	return months[monthIndex] || monthString;
};
